// Metadata for the Regex Golf holes. `par` is the length of the tightest known
// pattern (characters inside the #"..."). Exercise ids must match the `golf.id`
// set on the corresponding golf exercises in regexPart3.js.
export const GOLF_HOLES = [
  { id: "double", name: "Doubled character", par: 5 },
  { id: "novowel", name: "No vowels", par: 9 },
  { id: "hashtag", name: "Hashtag", par: 4 },
  { id: "three", name: "Exactly three chars", par: 5 },
];
